module.exports = __webpack_public_path__ + "static/media/25542601_1703517973056720_3172791589175900676_o.0df824a7.jpg";